import React, { useEffect, useState } from 'react';
import { Lounge } from '@bizzabo/seismo-ui';
import moment from 'moment';

const getCountdown = (timeToStartInMilliseconds, waitingRoomOffsetMinutes) => {
    if (waitingRoomOffsetMinutes && timeToStartInMilliseconds > 0) {
        const interval = moment.duration(timeToStartInMilliseconds);
        return interval?.format('mm:ss', { trim: false });
    }

    return null;
};

export const useWaitingRoomCountdown = (
    waitingRoom, timeToStartInMilliseconds
) => {
    const { countdownEnabled, startTime } = waitingRoom;

    const [finished, setFinished] = useState(timeToStartInMilliseconds <= 0);
    const [countdown, setCountdown] = useState(null);

    useEffect(() => {
        if (countdownEnabled && timeToStartInMilliseconds > 0) {
            const formattedCountdown = getCountdown(
                timeToStartInMilliseconds,
                startTime
            );

            setCountdown(formattedCountdown);
        } else {
            setFinished(true);
        }
    }, [timeToStartInMilliseconds, startTime, countdownEnabled]);

    return {
        countdown: countdown,
        finished: finished
    };
};

const DEFAULT_WELCOMING_TEXT = 'This session will begin shortly';

const LoungeWaitingRoom = ({ session, me, timeToStartInMilliseconds }) => {
    const { countdown, finished } = useWaitingRoomCountdown(
        session.waitingRoom,
        timeToStartInMilliseconds
    );

    const { musicId, musicEnabled, welcomingText, countdownEnabled } = session.waitingRoom;

    return (
        <div className='waiting-room-container'>
            <Lounge
                className='waiting-room-lounge'
                loungeMusicId={musicEnabled && musicId}
            >
                <div className='waiting-room-foreground'>
                    <span
                        className='waiting-room-welcome'
                    >Welcome {`${me.firstName || ''}`}</span>
                    <span className='waiting-room-description'>
                        {welcomingText || DEFAULT_WELCOMING_TEXT}
                    </span>
                    {countdownEnabled && !finished && (
                        <span className='waiting-room-countdown'>
                            {countdown}
                        </span>
                    )}
                </div>
            </Lounge>
        </div>
    );

};

export default LoungeWaitingRoom;
